import { Menu, X } from "lucide-react";
import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";

const AdminPage = () => {
  const menuItems = [
    { name: "Dashboard", path: "/admin-panel" },
    { name: "Requests", path: "/admin-panel/requests" },
    { name: "DJs", path: "/admin-panel/djs" },
    { name: "Places", path: "/admin-panel/places" },
    { name: "Transactions", path: "/admin-panel/transactions" },
    { name: "Invite token", path: "/admin-panel/invite-token" },
    { name: "Invitations", path: "/admin-panel/invitations" },
  ];

  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar for larger screens */}
      <aside className="hidden md:flex flex-col w-64 bg-white shadow-md p-4">
        <NavLink
          to="/admin-panel"
          className="mb-4 text-2xl font-bold text-gray-800 hover:text-blue-500 transition"
        >
          Admin Panel
        </NavLink>
        <nav className="flex flex-col space-y-2">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/admin-panel"}
              className={({ isActive }) =>
                `p-3 rounded-lg transition ${
                  isActive
                    ? "bg-blue-500 text-white"
                    : "text-gray-700 hover:bg-gray-200"
                }`
              }
            >
              {item.name}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Mobile Navbar */}
      <div className="md:hidden fixed top-0 left-0 w-full bg-white shadow-md p-4 flex justify-between items-center z-30">
        <NavLink
          to="/admin-panel"
          className="text-xl font-bold text-gray-800 hover:text-blue-500 transition"
        >
          Admin Panel
        </NavLink>
        <button onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}>
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Sidebar */}
      {isMobileMenuOpen && (
        <>
          <div
            className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-20"
            onClick={() => setMobileMenuOpen(false)}
          />
          <aside className="fixed top-14 left-0 h-[calc(100%-3rem)] w-64 bg-white shadow-md p-4 z-30 overflow-y-auto">
            <nav className="flex flex-col space-y-2">
              {menuItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === "/admin-panel"}
                  className={({ isActive }) =>
                    `p-3 rounded-lg transition ${
                      isActive
                        ? "bg-blue-500 text-white"
                        : "text-gray-700 hover:bg-gray-200"
                    }`
                  }
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </NavLink>
              ))}
            </nav>
          </aside>
        </>
      )}

      {/* Main Content */}
      <main className="flex-1 p-6 mt-16 md:mt-0 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminPage;
